import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  class: "copy-day-modal",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "copy-day-modal-title"
}
const _hoisted_2 = { class: "copy-day-content" }
const _hoisted_3 = { class: "copy-from" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "copy-to" }
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = ["id", "value", "aria-label"]
const _hoisted_9 = ["for"]
const _hoisted_10 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("h3", {
      id: "copy-day-modal-title",
      class: "mb-3"
    }, [
      _createElementVNode("i", { class: "fa fa-copy" }),
      _createTextVNode(" Copy Day ")
    ], -1)),
    _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "title-separator" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mb-2" }, [
          _createElementVNode("b", null, "Copy From:")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.copyFrom) = $event)),
            "aria-label": "Select the day to copy from",
            class: "form-select mb-3"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
              return (_openBlock(), _createElementBlock("option", {
                key: day,
                value: day
              }, _toDisplayString(day), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.copyFrom]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mb-2" }, [
          _createElementVNode("b", null, "Copy To:")
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
            return (_openBlock(), _createElementBlock("div", {
              key: day,
              class: "form-check mb-2"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: day,
                value: day,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.copyTo) = $event)),
                "aria-label": `Select ${day} to copy to`,
                class: "form-check-input"
              }, null, 8, _hoisted_8), [
                [_vModelCheckbox, _ctx.copyTo]
              ]),
              _createElementVNode("label", {
                for: day,
                class: "form-check-label"
              }, _toDisplayString(day), 9, _hoisted_9)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
        class: "btn btn-secondary me-2"
      }, "Cancel"),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args))),
        class: "btn btn-primary"
      }, "Copy")
    ])
  ]))
}